import { IconLoader2 } from '@tabler/icons-react';
import ContentDialog from '@/Pages/Sessions/uiComponents/ContentDialog/ContentDialog';
import Button from '@/components/atoms/Button/Button';
import { CLIP_POPOVER_ASSUME_INSIDE_CLASS_NAME } from '@/Pages/SessionDetail/constants';

export default function ConfirmationDialog({
  isOpen,
  title,
  content,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmTrackingId = 'confirmation-dialog-confirm-button',
  cancelTrackingId = 'confirmation-dialog-confirm-button',
  confirmLoading = false,
  actionsLayout = 'between',
  onClose,
  onConfirm
}: {
  isOpen: boolean;
  title: string;
  content: string | React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmTrackingId?: string;
  cancelTrackingId?: string;
  confirmLoading?: boolean;
  actionsLayout?: 'end' | 'between';
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <ContentDialog
      className={CLIP_POPOVER_ASSUME_INSIDE_CLASS_NAME}
      title={title}
      size="small"
      isOpen={isOpen}
      setIsOpen={onClose}
    >
      <div className="flex flex-col">
        <p className="p-4 text-sm">{content}</p>
        <div
          className={`flex items-center ${actionsLayout === 'end' ? 'justify-end' : 'justify-between'} gap-3 border-t border-t-slate-200 p-2`}
        >
          {confirmLoading ? (
            <div />
          ) : (
            <Button variation="outline" trackingId={cancelTrackingId} onClick={onClose}>
              {cancelLabel}
            </Button>
          )}
          <Button variation="filled" disabled={confirmLoading} trackingId={confirmTrackingId} onClick={onConfirm}>
            {confirmLoading ? <IconLoader2 className="animate-spin" size={16} /> : confirmLabel}
          </Button>
        </div>
      </div>
    </ContentDialog>
  );
}
